module.exports = __webpack_public_path__ + "static/media/nosound.3d6cebb8.mp3";